import { render, staticRenderFns } from "./ContentTypeDetail.vue?vue&type=template&id=2a549d0a&scoped=true"
import script from "./ContentTypeDetail.vue?vue&type=script&lang=js"
export * from "./ContentTypeDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a549d0a",
  null
  
)

export default component.exports